import React, { useEffect, useState } from "react";
import Layout from "../../../../Components/Common/Layout";
import DashLayout from "../../../../Components/Admin/AdminDashLayout";
import { useDispatch } from "react-redux";
import InvestmentTable from "./InvestmentTable";
import InvestmentDetailsDrawer from "./InvestmentDetailsDrawer";
import { getInvestmentsThunk } from "../../../../Store/Slices/Finance/investments/investment.thunk";
import { fetchEntity } from "../../../../Store/Slices/Finance/entitie/entity.thunk";
import useNavHeading from "../../../../Hooks/CommonHooks/useNavHeading ";
import ProtectedSection from "../../../../Routes/ProtectedRoutes/ProtectedSection";
import { PERMISSIONS } from "../../../../config/permission";
import ProtectedAction from "../../../../Routes/ProtectedRoutes/ProtectedAction";

const InvestmentMain = () => {
  useNavHeading("Finance", `Investments`);

  const dispatch = useDispatch();

  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    dispatch(getInvestmentsThunk());
    dispatch(fetchEntity());
  }, [dispatch]);

  return (

    <Layout title={"Investment | Office Flow"}>
      <DashLayout>
        <ProtectedSection requiredPermission={PERMISSIONS.VIEW_SHARE_HOLDERS} title={"Share Holders"}>
          <div className="p-4 bg-gray-50 min-h-screen">
            <div className="flex justify-between items-center mb-4 bg-white rounded-xl shadow-sm p-4">
              <div>
                <h2 className="page-heading">Share Holders</h2>
                <p className="subheading"> Track and manage all share holder records</p>
              </div>
              <ProtectedAction requiredPermission={PERMISSIONS.ADD_SHARE_HOLDERS}>

                <button
                  type="primary"
                  onClick={() => setDrawerOpen(true)}
                  className="btn-gradient p-3"
                >
                  + Add Share Holder
                </button>
              </ProtectedAction>
            </div>

            <InvestmentTable />

            <InvestmentDetailsDrawer
              open={drawerOpen}
              onClose={() => setDrawerOpen(false)}
              mode="add"
            />
          </div>
        </ProtectedSection>
      </DashLayout>
    </Layout >

  );
};

export default InvestmentMain;
